import { hotjar } from 'react-hotjar';

/**
 * Sends an event to Hotjar for tracking
 * @param eventName The name of the event to track
 */
export const hotjarEvent = (eventName: string): void => {
  if (!hotjar.initialized()) return;

  hotjar.event(eventName);
};
